<form [formGroup]="form" #clientJobForm="ngForm" (ngSubmit)="container.scrollTop = 0; onSubmit()" class="" novalidate>
    <div class="addSPanimate dms-upload-doc-popup-container">
        <div class="bg-white br-15px">
            <div class="cmn-modal-header">
                <h4 class="modal-header-title">Upload document</h4>
            </div>
            <div class="cmn-modal-content" #container>
                <div class="">
                    <div *ngIf="!canShowFolderLocationField" class="form-group folder-path-text">
                        <div class="custom-row">
                            <div class="col-12">
                                <span class="breadcrumb-truncate mt-1 d-block" [matTooltip]="breadcrumbInfo?.clientName + ' / ' + breadcrumbInfo?.breadcrumbPath"  matTooltipClass="cmn-tooltip-template">
                                    {{getShortBreadcrumb() }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- Client Name -->
                    <div class="form-group" [hidden]="NoUse">
                        <div class="custom-row align-items-center">
                            <h6 class="cmn-form-label mb-0 text-left col-4">
                                <span>Client name<span *ngIf="SiteType == 'globalUpload'" class="error-text">*</span></span>
                            </h6>
                            <div class="col-8">
                                <div class="form-select-container w-260">
                                    <ng-select [items]="clients" [virtualScroll]="true" [searchable]="true" data-testid="drpdwn-client-name" class="cmn-ngselect" bindLabel="Name"
                                        bindValue="ClientId" formControlName="clientId" placeholder="Select Client Name"
                                        (change)="onClientChange($event, 'client')" (clear)="onClientClear()">
                                        <ng-template ng-option-tmp let-item="item" let-index="index">
                                            <span>{{item.Name.length > 15 ? (item.Name | slice: 0: 15) + '..' :
                                                item.Name}}</span>
                                        </ng-template>
                                    </ng-select>
                                </div>
                                <div class="invalid-feedback" *ngIf="form?.get('clientId')?.touched && form?.get('clientId')?.invalid">
                                    Client name is required.
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Client Group -->
                    <div class="form-group" [hidden]="NoUse">
                        <div class="custom-row align-items-center">
                            <h6 class="cmn-form-label mb-0 text-left col-4">
                                Client group
                            </h6>
                            <div class="col-8">
                                <div class="form-input-container w-260">
                                    <input type="text" data-testid="inp-client-group" class="form-control" formControlName="clientGroup"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Client Code -->
                    <div class="form-group" [hidden]="NoUse">
                        <div class="custom-row align-items-center">
                            <h6 class="cmn-form-label mb-0 text-left col-4">
                                Client code
                            </h6>
                            <div class="col-8">
                                <div class="form-input-container w-260">
                                    <input type="text" data-testid="inp-client-code" class="form-control" formControlName="clientCode"/>
                                </div>
                            </div>
                        </div>
                    </div>
                     <!-- folder location -->
                    <div class="form-group" *ngIf="canShowFolderLocationField">
                        <div class="custom-row align-items-center">
                            <h6 class="cmn-form-label mb-0 text-left col-4">
                                Folder location<span class="error-text">*</span>
                            </h6>
                            <div class="col-8">
                                <div class="form-input-container folder-location-input w-260">
                                    <input type="text" data-testid="inp-folder-location" class="form-control cursor-pointer" placeholder="Select folder location" formControlName="folderLocation" [readonly]="true" (click)="openFolderLocationPopup()" (mousedown)="$event.preventDefault()" required>
                                </div>
                                <div class="invalid-feedback" *ngIf="form.get('folderLocation')?.touched && form.get('folderLocation')?.invalid">
                                    Folder location is required.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <div *ngFor="let field of metaDataFields" class="custom-row align-items-center row-adjustment">
                            <h6 [attr.for]="field.SharepointSiteMetadataId" class="cmn-form-label mb-0 text-left col-4">
                                {{ field.FieldLabel }}
                                <span *ngIf="field.Mandate" class="error-text">*</span>
                            </h6>
                            <div [ngSwitch]="field.DataType" class="col-8">
                                <div class="form-input-container w-260">
                                    <!-- Text input -->
                                    <input *ngSwitchCase="'TEXT'" data-testid="inp-meta-data" class="form-control"
                                        [formControlName]="field.SharepointSiteMetadataId.toString()" type="text"
                                        (input)="
                                          updateFormValuesArray(
                                            field.SharepointSiteMetadataId,
                                            $event.target
                                          )
                                        " />

                                    <!-- Choice select -->
                                    <div class="form-multiselect-container" *ngSwitchCase="'CHOICE'">
                                        <ng-multiselect-dropdown class="cmn-multiselect-dropdown ellipsis-itemname"
                                            data-testid="mslct-meta-data"
                                            [placeholder]="'Select option'" [settings]="dropdownSettings1"
                                            [data]="field.choiceArray" (onSelect)="onItemSelect($event, field)"
                                            (onSelectAll)="onSelectAll($event, field)"
                                            (onDeSelect)="onDeSelect($event, field)"
                                            (onDeSelectAll)="onItemDeSelectAll(field)"
                                            [formControlName]="field.SharepointSiteMetadataId.toString()">
                                        </ng-multiselect-dropdown>
                                    </div>

                                    <!-- Date input -->
                                    <div class="form-datepicker-container cmn-material-datepicker"
                                        *ngSwitchCase="'DATE'">
                                        <mat-form-field floatLabel="never" appearance="standard">
                                            <input data-testid="inp-dtpkr-meta-data" class="cmn-mat-dtpicker-input" matInput [max]="maxDate"
                                                [formControlName]="field.SharepointSiteMetadataId.toString()"
                                                [matDatepicker]="metaDataDatePicker" autocomplete="off"
                                                placeholder="dd/mm/yyyy" (dateChange)="checkOnchangefield()">
                                            <mat-datepicker-toggle data-testid="trgr-dtpkr-meta-data" class="cmn-mat-dtpicker-togglebtn" matIconSuffix
                                                [for]="metaDataDatePicker"></mat-datepicker-toggle>
                                            <mat-datepicker panelClass="cmn-datepicker-ui" #metaDataDatePicker></mat-datepicker>
                                        </mat-form-field>
                                    </div>

                                    <!-- Yes/No radio buttons -->
                                    <div class="form-radio-inline d-flex" *ngSwitchCase="'YESNO'">
                                        <div class="fncy-radio-button form-check-inline fncy-default-radio">
                                            <input type="radio" data-testid="rdo-yes-sp-meta-data"
                                                [formControlName]="field.SharepointSiteMetadataId.toString()"
                                                value="true" class="check_box_add_contact_css check-label radio-button"
                                                id="yes{{ field.SharepointSiteMetadataId }}"
                                                name="cfchkbox-{{ field.SharepointSiteMetadataId }}"
                                                (change)="onYesNoChange($event, field, 'true')" />
                                            <label class="radio-btn-label"
                                                for="yes{{ field.SharepointSiteMetadataId }}">Yes</label>
                                        </div>
                                        <div class="fncy-radio-button form-check-inline fncy-default-radio">
                                            <input type="radio" data-testid="rdo-no-sp-meta-data"
                                                [formControlName]="field.SharepointSiteMetadataId.toString()"
                                                value="false" class="check_box_add_contact_css check-label radio-button"
                                                id="no{{ field.SharepointSiteMetadataId }}"
                                                name="cfchkbox-{{ field.SharepointSiteMetadataId }}"
                                                (change)="onYesNoChange($event, field, 'false')" />
                                            <label class="radio-btn-label"
                                                for="no{{ field.SharepointSiteMetadataId }}">No</label>
                                        </div>
                                    </div>
                                    <!-- Error message -->
                                    <div *ngIf="isFieldInvalid(field.SharepointSiteMetadataId.toString())"
                                        class="invalid-feedback invalid">
                                        {{field.FieldLabel}} is required
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- File Upload -->
                    <div class="form-group" *ngIf="canShowBrowseFiles">
                        <div class="custom-row">
                            <h6 class="cmn-form-label mb-0 text-left col-4 position-relative mt-2">
                                Upload<b class="error-text">*</b>
                            </h6>
                            <div class="col-8" id="fileUploadContainer">
                                <div class="w-260">
                                    <input type="file" data-testid="inp-file-type-meta-data" multiple id="fileUpload" (change)="onFileSelected($event)"
                                        [formControl]="fileUpload">
                                    <label for="fileUpload" class="file-upload-label file-upload-container">
                                        <div>
                                            Choose a file or drag it here
                                        </div>
                                        <div>
                                            <label for="fileUpload" class="w-100">or</label>
                                            <label for="fileUpload" class="browsefiles">Browse files</label>
                                        </div>
                                    </label>
                                    <div *ngIf="isFieldInvalid('fileUpload')" class="invalid-feedback invalid">
                                        Upload one or more file is required
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" *ngIf="files.length>0">
                        <div class="custom-row">
                            <div class="col-12 file-uploads">
                                <div class="row mx-0">
                                    <div class="name item col-5">File</div>
                                    <div class="rename item col-7 pl-0">Rename</div>
                                </div>
                                <div class="row mx-0">
                                    <div class="hr"></div>
                                </div>
                                <div class="filedetails">
                                    <div class="row mx-0 mt-2" *ngFor="let fileInfo of files; let i=index;">
                                        <div class="item col-5">
                                            <div class="nameOfFile px-0">
                                                {{fileInfo?.file?.name}}
                                            </div>
                                        </div>
                                        <div class="col-7 px-0 d-flex align-items-center">
                                            <input type="text" data-testid="inp-file-name" [value]="fileInfo.editableName"
                                                (input)="updateFileName(i, $event.target.value)">

                                            <div class="text-danger" *ngIf="invalidFileNames[i]">
                                                <small>{{ invalidFileNames[i] }}</small>
                                            </div>
                                            <p class="pl-2 pt-0 mb-0 cursor-pointer text-center crossMark"
                                                (click)="deleteFile(i)"> <img alt=""
                                                    src="../../../../assets/img/close-gray.svg"
                                                    class="img-responsive" /></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <div class="cmn-modal-footer">
                <button type="submit" mat-button class="cmn-blue-btn" data-testid="btn-submit-upload-document" [disabled]="hasInvalidFileNames() || checkDisableButton">Upload</button>
                <button type="button" #cancelUploaddocument class="cmn-inverse-btn" data-testid="btn-cancel-upload-document" mat-button data-dismiss="modal"
                    (click)="container.scrollTop = 0; onCancelClicked()">Cancel</button>
            </div>
        </div>
    </div>
</form>

<div class="drop-overlay" *ngIf="isDraggingOver">
    <p>Drop files here to upload</p>
</div>

<!-- folder location popup -->
<ng-template #folderLocationPopupRef>
    <app-dms-folder-location (outputParameter)="hideFolderLocationPopUp()" (sendFolderLocation)="sendFolderLocation($event)"
        [ClientId]="uploadFolderpopupData?.clientId" [currentFolderLocId]="uploadFolderpopupData?.currentFolderLocationId">
    </app-dms-folder-location>
</ng-template>